import { Button, Typography, Descriptions } from 'antd';
import { FormOutlined } from '@ant-design/icons';
import { t } from '@/utils/translator';
import useAuthStore from '@store/useAuthStore';
import { useApi } from '@/hooks/useApi';

const { Title } = Typography;

const SiteDescriptionCard = ({ ActiveEstimateSite, onEditSite, descStyleHeader, descStyleBody }) => {
  const user = useAuthStore((state) => state.user);

  // useState와 useEffect를 useApi 훅으로 대체
  const { data: siteData, loading } = useApi(
    ActiveEstimateSite ? '/sites' : null, // ActiveEstimateSite가 있을 때만 요청
    { params: { site_id: ActiveEstimateSite } }
  );

  // API는 배열을 반환하므로 첫 번째 요소를 사용
  const Site = siteData?.[0];

  return (
    <>
      <div className="d-flex justify-content-between mb-2">
        <Title level={4} className="text-dark mb-0">
          {t('사업장 정보')}
        </Title>
        <Button icon={<FormOutlined />} onClick={() => onEditSite(Site)} disabled={!Site || loading}>
          {t('사업장 정보 수정')}
        </Button>
      </div>

      {loading && <div className="p-5 text-center">Loading...</div>}
      {!loading && Site && (
        <Descriptions
          column={6}
          size="small"
          className="border"
          labelStyle={descStyleHeader}
          contentStyle={descStyleBody}
          layout="vertical"
          bordered
        >
          <Descriptions.Item label={t('사업장명')}>{Site.site_name}</Descriptions.Item>
          <Descriptions.Item label={t('소속 기업')}>{user.company_name}</Descriptions.Item>
          <Descriptions.Item label={t('사업장 국가')}>{Site.site_country}</Descriptions.Item>
          <Descriptions.Item label={t('사업장 주소')}>{Site.site_location}</Descriptions.Item>
          <Descriptions.Item label={t('HL 만도 거래법인')}>
            {Site.site_clients?.join(', ')}
          </Descriptions.Item>
        </Descriptions>
      )}
    </>
  );
};

export default SiteDescriptionCard;
